import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf9739e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "transaction-info"
}
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "table-label" }
const _hoisted_4 = { class: "has-text-right" }
const _hoisted_5 = { class: "status info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "table-label" }
const _hoisted_8 = { class: "has-text-right" }
const _hoisted_9 = { class: "status info" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = { class: "table-label" }
const _hoisted_13 = { class: "sub-text mt-1" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { colspan: "2" }
const _hoisted_16 = { class: "table-label" }
const _hoisted_17 = {
  class: "monospace signature sub-text mt-1",
  "data-testid": "error-signature"
}
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { colspan: "2" }
const _hoisted_20 = { class: "table-label" }
const _hoisted_21 = { class: "scrollable mt-1" }
const _hoisted_22 = { class: "monospace" }
const _hoisted_23 = { class: "byte-wrap" }

import { stripHexPrefix } from 'web3-utils'
import { computed } from 'vue'

import Sanitize from '@/popup/components/shared/Sanitize.vue'
import { highlightSignature } from '@/popup/utils/highlightSignature'
import { Transaction } from '@/shared/models/Transaction'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { ErrorTypeMap } from '@/background/utils/decodeNetworkError'
import { ErrorType, FullDetailedError } from '@/shared/models/DetailedError'
import { DecodedValue } from '@/popup/compositions/useABIDecoder'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvancedError',
  props: {
    transaction: {}
  },
  setup(__props: any) {

const props = __props

const ERROR_OR_PANIC = new Set(['Error', 'Panic'])

const error = computed(() => {
  return props.transaction.error as FullDetailedError
})

const description = computed(() => {
  const {
    transaction: { error },
  } = props
  const {
    userdoc,
    advanced: { name, devdoc, inputs = [] } = { name: '', devdoc: '' },
  } = (error as FullDetailedError) || {}

  if (ERROR_OR_PANIC.has(name) && devdoc) {
    // Error and Panic only have devdoc (which is artifically injected by decoder)
    return devdoc
  }
  if (
    inputs?.length === 1 &&
    inputs?.[0]?.type === 'string' &&
    (inputs?.[0]?.value || '').split(' ').length > 1
  ) {
    // If the Error only has a single string parameter and that string has multiple
    // words then it's likely to be an error string to be displayed.
    return inputs[0].value
  }
  return userdoc
})

return (_ctx: any,_cache: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_Tooltip, {
                    value: _ctx.$t('transaction.error.type_tooltip'),
                    "offset-distance": "0",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: "info-circle",
                        class: "is-flex",
                        fill: "--neutral-60"
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["value"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.error.type')), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(_unref(ErrorTypeMap)[error.value.type || _unref(ErrorType).INVALID])), 1 /* TEXT */)
              ])
            ]),
            (error.value.advanced?.name === 'Panic')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Tooltip, {
                        value: _ctx.$t('transaction.error.code_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.error.code')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(error.value.advanced?.inputs?.[0].value || 'Unknown'), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (description.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Tooltip, {
                        value: _ctx.$t('transaction.error.description_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.error.description')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(description.value), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (
            error.value?.advanced?.sig &&
            !(
              _unref(ERROR_OR_PANIC).has(error.value?.advanced?.name) &&
              error.value?.advanced?.inputs?.length === 1
            )
          )
              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Tooltip, {
                        value: _ctx.$t('transaction.error.info_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.error.info')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(Sanitize, {
                        html: 
                  _unref(highlightSignature)(
                    error.value?.advanced?.sig,
                    // Create a map of inputs [`0`-`n`] = VALUE
                    error.value?.advanced?.inputs?.reduce(
                      (output, { value }, index) => {
                        output[index] = value
                        return output
                      },
                      {}
                    ),
                    // Create a map of docs [`0`-`n`] = DOC
                    error.value?.advanced?.inputs?.reduce(
                      (output, { doc }, index) => {
                        output[index] = doc
                        return output
                      },
                      {}
                    )
                  )
                
                      }, null, 8 /* PROPS */, ["html"])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (error.value?.data && !_unref(ERROR_OR_PANIC).has(error.value?.advanced?.name || ''))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Tooltip, {
                        value: _ctx.$t('transaction.error.data_tooltip'),
                        "offset-distance": "0",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SvgIcon, {
                            name: "info-circle",
                            class: "is-flex",
                            fill: "--neutral-60"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('transaction.error.data')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(error.value?.data ? _unref(stripHexPrefix)(error.value?.data) : ''), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})